import { useState } from "react";
import { Phone, Mail, Instagram, Music2 } from "lucide-react";
import { MaskReveal, Reveal } from "./Reveal";
import { BUSINESS } from "./data";

export const Booking = () => {
  const [year] = useState(new Date().getFullYear());

  return (
    <footer id="booking" className="relative overflow-hidden bg-ink-950 pt-28 md:pt-44">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-gold/10 blur-[140px]" />

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="text-center md:text-left">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ Book Jazzy the Great</span>
          </Reveal>
          <h2 className="mt-6 font-oswald text-[15vw] font-700 uppercase leading-[0.82] tracking-tighter text-white md:text-[11vw]">
            <MaskReveal lines={["Let's Make"]} />
            <MaskReveal lines={["It Loud"]} className="text-stroke-gold" delay={0.1} />
          </h2>
        </div>

        <div className="mt-20 grid gap-10 border-t border-white/10 pt-14 md:grid-cols-3">
          <Reveal>
            <a
              data-testid="contact-phone"
              href={BUSINESS.phoneHref}
              className="group flex flex-col gap-3"
            >
              <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">
                <Phone size={13} className="text-gold" /> Call / Text
              </span>
              <span className="font-oswald text-2xl font-500 uppercase tracking-tight text-white group-hover:text-gold transition-colors duration-300 md:text-3xl">
                {BUSINESS.phone}
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.1}>
            <a
              data-testid="contact-email"
              href={BUSINESS.emailHref}
              className="group flex flex-col gap-3"
            >
              <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">
                <Mail size={13} className="text-gold" /> Booking Inquiries
              </span>
              <span className="font-oswald text-2xl font-500 lowercase tracking-tight text-white group-hover:text-gold transition-colors duration-300 md:text-3xl">
                {BUSINESS.email}
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="flex flex-col gap-3">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">Follow the Sound</span>
              <div className="flex items-center gap-4">
                <a
                  data-testid="footer-instagram"
                  href={BUSINESS.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="flex h-12 w-12 items-center justify-center border border-white/15 text-white hover:border-gold hover:text-gold transition-colors duration-300"
                >
                  <Instagram size={18} />
                </a>
                <a
                  data-testid="footer-soundcloud"
                  href={BUSINESS.soundcloud}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="SoundCloud"
                  className="flex h-12 w-12 items-center justify-center border border-white/15 text-white hover:border-gold hover:text-gold transition-colors duration-300"
                >
                  <Music2 size={18} />
                </a>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 md:flex-row">
          <span className="font-oswald text-sm uppercase tracking-[0.3em] text-white">
            Jazzy<span className="text-gold">.</span> The Great
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © {year} — All Rights Reserved
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Long Island, New York
          </span>
        </div>
      </div>
    </footer>
  );
};
